/**
 * 通道混合器（对比 Photoshop 补全第一档缺口 阶段 1）。
 *
 * 只做"自定义"模式：每个输出通道 = 三个输入通道按百分比加权 + 常量偏移
 * （常量单位同样是百分之几个满白 255）。不做预置的黑白/红外下拉——那是
 * UI 糖，不是核心数学，用户可以自己把权重调到黑白配方。
 */
export interface ChannelMixerParams {
  readonly rr: number;
  readonly rg: number;
  readonly rb: number;
  readonly rc: number;
  readonly gr: number;
  readonly gg: number;
  readonly gb: number;
  readonly gc: number;
  readonly br: number;
  readonly bg: number;
  readonly bb: number;
  readonly bc: number;
}

/** 恒等参数：每个输出通道 100% 来自同名输入通道，常量偏移 0。 */
export const DEFAULT_CHANNEL_MIXER_PARAMS: ChannelMixerParams = {
  rr: 100,
  rg: 0,
  rb: 0,
  rc: 0,
  gr: 0,
  gg: 100,
  gb: 0,
  gc: 0,
  br: 0,
  bg: 0,
  bb: 100,
  bc: 0,
};

function mix(r: number, g: number, b: number, mr: number, mg: number, mb: number, mc: number): number {
  return r * (mr / 100) + g * (mg / 100) + b * (mb / 100) + (mc / 100) * 255;
}

export function applyChannelMixer(
  r: number,
  g: number,
  b: number,
  p: ChannelMixerParams,
): [number, number, number] {
  const clamp = (v: number): number => Math.round(Math.min(255, Math.max(0, v)));
  return [
    clamp(mix(r, g, b, p.rr, p.rg, p.rb, p.rc)),
    clamp(mix(r, g, b, p.gr, p.gg, p.gb, p.gc)),
    clamp(mix(r, g, b, p.br, p.bg, p.bb, p.bc)),
  ];
}
